import React, { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import PageMeta from "@/components/PageMeta";
import ScheduleTable from "@/components/ScheduleTable";
import { api } from "@/lib/api";

export default function Schedule() {
  const [schedule, setSchedule] = useState([]);
  const [teams, setTeams] = useState([]);
  useEffect(() => {
    api.get("/schedule").then((r) => setSchedule(r.data)).catch(() => {});
    api.get("/teams").then((r) => setTeams(r.data)).catch(() => {});
  }, []);
  const bySlug = Object.fromEntries(teams.map((t) => [t.slug, t]));

  return (
    <div>
      <PageMeta
        title="Season Schedule — PSHL8 Match Center"
        description="Full inaugural-season match calendar across all eight PSHL8 franchises."
        image="/api/og/schedule/og-image.png"
      />
      <PageHero
        overline="Match Center"
        title={<>Season Schedule.</>}
        subtitle="Full inaugural-season match calendar across all eight franchises."
        bgImage="https://images.pexels.com/photos/34383777/pexels-photo-34383777.jpeg"
      />
      <section className="section pt-0">
        <div className="pshl-container">
          <ScheduleTable schedule={schedule} teamsBySlug={bySlug} />
        </div>
      </section>
    </div>
  );
}
